import { render, staticRenderFns } from "./GuangzhouTelecomJd.vue?vue&type=template&id=0a0fedf0&scoped=true"
import script from "./GuangzhouTelecomJd.vue?vue&type=script&lang=js"
export * from "./GuangzhouTelecomJd.vue?vue&type=script&lang=js"
import style0 from "./GuangzhouTelecomJd.vue?vue&type=style&index=0&id=0a0fedf0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0fedf0",
  null
  
)

export default component.exports